<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PropertyStatusListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PropertyStatusListing from "@/views/pages/admin/propertyStatus/propertyStatusListing";

export default {
    page: {
        title: i18n.t("module.propertyStatus"),
    },
    components: { Layout, PageHeader, PropertyStatusListing },
    data() {
        return {
            title: i18n.t("module.propertyStatus"),
            items: [
                {
                    text: i18n.t("module.property"),
                    href: '/properties',
                },
                {
                    text: i18n.t("module.propertyStatus"),
                    active: true,
                },
            ],
        };
    },
}
</script>
